<div class="matero-auth-container">
  <router-outlet></router-outlet>
</div>
